import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import BoundedPageLayout from '../../../components/dashboard/BoundedPageLayout';
import PageHeader from '../../../components/dashboard/PageHeader';
import ContactDetailContent from '../../../components/contacts/ContactDetailContent';
import { useContactQuery } from '../../../components/contacts/useContactQueries';
import { contactLeadsPath } from './columns';

export default function ContactDetail() {
  const { id } = useParams();
  const { t } = useTranslation();
  // Same query as ContactDetailContent (deduped by react-query), only for the title.
  const { data } = useContactQuery(id);
  const title = data?.display_name || t('contacts.detailTitle');

  const header = (
    <PageHeader
      title={title}
      breadcrumbs={[
        { label: t('contacts.breadcrumb.dashboard') },
        { label: t('nav.groups.service') },
        { label: t('contacts.breadcrumb.list'), to: '/contacts' },
        { label: title },
      ]}
    />
  );

  return (
    <BoundedPageLayout header={header}>
      <ContactDetailContent
        uuid={id}
        renderActions={(contact) => (
          <Button
            variant="contained"
            startIcon={<ForumOutlinedIcon />}
            component={RouterLink}
            to={contactLeadsPath(contact)}
          >
            {t('contacts.actions.viewConversations')}
          </Button>
        )}
      />
    </BoundedPageLayout>
  );
}
